import React, { useMemo } from 'react'
import dynamic from 'next/dynamic'
import useIsMobile from 'hooks/useIsMobile'
import CustomImage from '@/Image'
// import Video from '@/UI/Video'

import { StyledMediaWithTagImage } from './styles'

const Video = dynamic(() => import('@/UI/Video'), { ssr: false, })
const MediaWithTag = ({
  title,
  keyword,
  media,
  videoMobile
}) => {
  const isMobile = useIsMobile()

  const isVideo = media && media.data && media.data.attributes.mime.includes('video')

  const mediaProps = useMemo(() => {
    const gotVideoMobile = videoMobile && videoMobile.data
    if (isVideo) {
      // Use mobile video by default if available and isMobile is undefined or true
      // This prevents switching from desktop to mobile video after hydration
      const shouldUseMobile = gotVideoMobile && (isMobile === true || (isMobile === undefined && gotVideoMobile))
      const videoProps = {
        type: 'video',
        title,
        sources: [{
          src: shouldUseMobile ? videoMobile.data.attributes.url : media.data.attributes.url,
          type: shouldUseMobile ? videoMobile.data.attributes.mime : media.data.attributes.mime,
          size: shouldUseMobile ? 720 : 1280,
        }]
      }

      return videoProps
    }

    return {
      as: 'div',
      media,
      rounded: 'big',
      tags: keyword ? [keyword] : false,
    }
  }, [isVideo, isMobile, videoMobile, media])

  return (
    isVideo
      ? <Video source={mediaProps} />
      : (
        <StyledMediaWithTagImage className='MediaWithTag'>
          <CustomImage {...mediaProps} />
        </StyledMediaWithTagImage>
      )
  )
}


export default MediaWithTag
